module.exports = __webpack_public_path__ + "img/electrical-technology.7a1f3b81.svg";